<table class="layout-fixed striped">
  <colgroup>
    <col class="width-33" />
    <col class="width-33" />
    <col class="width-33" />
  </colgroup>
  <thead>
    <tr>
      <th colspan="3">
        <h3>{{eventLogPrefix}}{{reportLogOfEvent.activityStream}}</h3>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr class="secondary-header">
      <td>{{StaticMessage.ActivityGroupColumn | staticMessage}}</td>
      <td class="text-center" i18n="@@report.reportEventsLogWithActivityGroups.colTotalDurationToday">
        Total duration today
      </td>
      <td class="text-center" i18n="@@report.reportEventsLogWithActivityGroups.colAccumulatedDurationToDate">
        Accumulated duration to date
      </td>
    </tr>
    <tr *ngFor="let logEvent of reportLogOfEvent.reportOfEventLog | sort: 'activityGroup': 'asc'">
      <td class="vertical-align-middle">{{logEvent.activityGroup}}</td>
      <td class="text-center vertical-align-middle">
        <span class="text-middle-right-aligned">{{logEvent.totalDurationToday}}</span>
      </td>
      <td class="text-center vertical-align-middle border-right">
        <span class="text-middle-right-aligned">{{logEvent.accumulatedDurationToDate}}</span>
      </td>
    </tr>
    <tr class="summary-total-row">
      <td class="accent vertical-align-middle">{{StaticMessage.TotalColumn | staticMessage}}</td>
      <td class="accent text-center vertical-align-middle">
        <span class="text-middle-right-aligned">
          {{reportLogOfEvent | sumLogOfEvents : 'totalDurationToday' : true}}
        </span>
      </td>
      <td class="accent text-center vertical-align-middle">
        <span class="text-middle-right-aligned">
          {{reportLogOfEvent | sumLogOfEvents : 'accumulatedDurationToDate' : true}}
        </span>
      </td>
    </tr>
  </tbody>
</table>
